import { AppointmentControllerApi } from "../services";
import { useDownloadReport } from "../hooks/use-download-report";
import { formatDateTime } from "../utils/date-time-utility";
import { getConfigObject, getXtenantId } from "../utils/utils";

export type ReportExportType = "CSV" | "PDF";

export const useAppointmentExportCsv = () => {
  const { download } = useDownloadReport();

  const exportAppointmentsCsv = (appointmentUuids: string[]) => {
    download({
      apiCall: new AppointmentControllerApi(
        getConfigObject()
      ).exportAppointmentsCsv(appointmentUuids, getXtenantId(), {
        responseType: "arraybuffer",
      }),
      fileName: `Appointment_Scheduling_Report ${formatDateTime(new Date())}.csv`,
      contentType: "text/csv",
    });
  };


  return { exportAppointmentsCsv };
};
